import React, { useState, useEffect } from 'react';
import LitImage from './images/LitImage';
import { Link } from 'gatsby';
import LitStructuredText from './generic/LitStructuredText';
import useScreenSize from '../hooks/useScreenSize';
const CampaignBenefits = ({ benefitData }) => {
  const screenSize = useScreenSize();
  const campaignBenefit = benefitData.map(
    (
      {
        heading,
        benefits,
        className,
        image,
        backgroundImageMobile,
        backgroundImageDesktop,
        link,
        path,
      },
      index,
    ) => {
      const benefitList = benefits.map(({ icon, content }, index) => {
        return (
          <div className="campaign-benefit-list-inner" key={index}>
            <div className="campaign-benefit-icon">
              <LitImage image={icon} alt="coloured icon" />
            </div>
            <div className="campaign-benefit-content">
              {content.value !== null && (
                <p>
                  <LitStructuredText data={content} basic />
                </p>
              )}
            </div>
          </div>
        );
      });
      return (
        <div className={`campaign-benefit ${className}`} key={index}>
          {!image && (
            <div className="campaign-background-image">
              <LitImage
                image={
                  screenSize.width >= 800
                    ? backgroundImageDesktop
                    : backgroundImageMobile
                }
                alt="people smiling"
              />
            </div>
          )}
          <div className="campaign-benefit-wrapper">
            <div className="campaign-benefit-wrapper-text">
              {heading && (
                <h2 className="campaign-benefit-heading">
                  <LitStructuredText data={heading} basic />
                </h2>
              )}
              <div className="campaign-benefit-list">{benefitList}</div>
              {link && (
                <Link to={path} className="button">
                  {link}
                </Link>
              )}
            </div>
            {image && (
              <div className="campaign-image-container">
                <LitImage image={image} alt="person working" />
              </div>
            )}
          </div>
        </div>
      );
    },
  );
  return campaignBenefit;
};

export default CampaignBenefits;
